module.exports = __webpack_public_path__ + "images/emoji/bento.24083c0ed72da3286eb6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bento.png
// module id = 4erm
// module chunks = 14